<div class="onsip-signup-left-side-content">
  <div class="onsip-logo"><img [src]="'resources/img/onsip-blue.svg'" alt="OnSIP Logo" /></div>
  <ng-content select="div.left-content"></ng-content>
</div>
@if (showRightContent | async) {
  <div class="onsip-signup-right-side-content">
    <div class="onsip-signup-blob-container">
      <img class="blob" [src]="'resources/img/preview-background-blob.svg'" alt="Background Blob" />
    </div>
    <ng-content select="div.right-content"></ng-content>
  </div>
}
